import type { CityConfig } from "../city-template/types";

export const rockfordConfig: CityConfig = {
  city: "Rockford",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "rockford",
  route: "/cities/rockford",
  title: "Emergency Passport Rockford, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Rockford, Illinois — as fast as 24 hours. Fast passport renewal and new passport applications for Rockford, Loves Park, Machesney Park, Belvidere, and all Winnebago County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Rockford, IL",
  heroSubtitle: "Rockford travelers — from the aerospace manufacturing corridor to Swedish American Hospital professionals to northern Illinois families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Rockford and the Stateline area.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Rockford%20Illinois%20downtown%20skyline%20along%20the%20Rock%20River%20with%20the%20Coronado%20Theatre%20sign%2C%20historic%20industrial%20architecture%20mixed%20with%20modern%20buildings%2C%20the%20river%20flowing%20through%20the%20city%20with%20tree-lined%20banks%2C%20warm%20afternoon%20sunlight%2C%20northern%20Illinois%20manufacturing%20city%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people%2C%20midwestern%20urban%20landscape%20with%20historic%20charm&width=1800&height=700&seq=rockford-hero-001&orientation=landscape",
  heroImageAlt: "Rockford Illinois downtown skyline along the Rock River with Coronado Theatre",
  geoPosition: "42.2711;-89.0940",
  geoPlacename: "Rockford, Illinois",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 90 miles, 1.5 hours via I-90",
  },
  nearbyCitiesZips: [
    { name: "Rockford", zips: "61101, 61102, 61103, 61104, 61107, 61108, 61109, 61114" },
    { name: "Loves Park", zips: "61111, 61130, 61131, 61132" },
    { name: "Machesney Park", zips: "61115" },
    { name: "Belvidere", zips: "61008" },
    { name: "Rockton", zips: "61072" },
    { name: "Roscoe", zips: "61073" },
    { name: "South Beloit", zips: "61080" },
    { name: "Poplar Grove", zips: "61065" },
    { name: "Byron", zips: "61010" },
    { name: "Cherry Valley", zips: "61016" },
    { name: "Winnebago", zips: "61088" },
    { name: "Pecatonica", zips: "61063" },
    { name: "Davis Junction", zips: "61020" },
    { name: "New Milford", zips: "61109" },
    { name: "Durand", zips: "61024" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — no 90-minute drive required" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Northern Illinois Hub", desc: "Serving Rockford aerospace, Swedish American Hospital, and Stateline families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no 90-minute trip to Chicago required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Naperville, IL", route: "/naperville" },
    { name: "Emergency passport help in Aurora, IL", route: "/aurora" },
    { name: "Urgent passport services in Joliet, IL", route: "/joliet" },
    { name: "Illinois passport services overview", route: "/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Rockford, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (90 minutes southeast via I-90) — without you making the trip. Rockford residents can ship from any UPS or FedEx in Winnebago County.",
  fpcOfficeDistance: "Serving Rockford, Loves Park, Machesney Park, Belvidere, Rockton, Roscoe, South Beloit, Poplar Grove, Byron, Cherry Valley, Winnebago, Pecatonica, and all of northern Illinois and the Stateline area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rockford and northern Illinois. From downtown Rockford along the Rock River to the aerospace manufacturing corridor, from Swedish American Hospital to the residential neighborhoods of the east and west sides — we serve all of Winnebago County and the Stateline area.",
  nearbyCitiesIntro: "We serve Rockford and all nearby communities including Loves Park, Machesney Park, Belvidere, Rockton, Roscoe, South Beloit, Poplar Grove, Byron, Cherry Valley, Winnebago, Pecatonica, Davis Junction, and Durand. We also serve Boone County, Stephenson County, and the Wisconsin Stateline communities.",
  howItWorksIntro: "Most Rockford travelers complete everything online and ship documents overnight. No need to drive 90 minutes to Chicago — our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Rockford is the largest city in northern Illinois with a strong aerospace manufacturing base, major healthcare system, and families across the Stateline. Here are the most common passport mistakes we see from Winnebago County travelers.",
  testimonialsIntro: "Rockford travelers — from the aerospace manufacturing corridor to Swedish American Hospital professionals to northern Illinois families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Rockford, IL? Here are the most common ones we hear from northern Illinois and Stateline travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 90-mile drive to Chicago required", "Perfect for aerospace and healthcare travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 90 miles to downtown Chicago", "Full day commitment — parking and downtown navigation"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Rockford travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Chicago Passport Agency — 90 minutes away but you never make the trip.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "Northern Illinois aerospace and healthcare travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Rockford adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Rockford address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Rockford residents and families — including new citizens, aerospace workers, and northern Illinois families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Rockford residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Rockford and northern Illinois families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Rockford and northern Illinois residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rockford IL", description: "Urgent passport processing for Rockford Illinois travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Rockford IL", description: "Fast passport renewal for Rockford Illinois residents with a previously-issued passport." },
    { name: "First-Time Passport Rockford IL", description: "New passport application services for Rockford Illinois residents applying for their first passport." },
    { name: "Child Passport Rockford IL", description: "Minor passport services for Rockford Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Michael S.",
      location: "Rockford, IL",
      rating: 5,
      text: "Aerospace conference in Toulouse in 6 days and my passport expired. Fast Passport Center had my renewed passport in 3 days. I shipped from the UPS Store on State Street and the whole process was seamless. Saved my business trip.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Karen W.",
      location: "Loves Park, IL",
      rating: 5,
      text: "Family vacation to Jamaica with 8 days notice. Four passports for our family. Done in 5 days. We shipped from FedEx on Riverside and everything was perfect. Worth every penny for the peace of mind.",
      service: "Family Passport Bundle",
    },
    {
      name: "Dr. Thomas H.",
      location: "Rockford, IL",
      rating: 5,
      text: "Medical conference in Singapore with 10 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The courier service is a game-changer for Rockford professionals — no way I could take a day to drive to Chicago.",
      service: "Emergency Passport",
    },
    {
      name: "Susan B.",
      location: "Machesney Park, IL",
      rating: 5,
      text: "Lost my passport the week before our cruise to the Bahamas. Fast Passport Center replaced it in 48 hours. From Machesney Park, the 90-minute drive to Chicago plus downtown parking would have been impossible. They saved our vacation.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "rock-1",
      name: "Rockford Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5223 Harrison Ave",
      city: "Rockford",
      state: "IL",
      zip: "61109",
      phone: "(815) 226-2211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Rockford, near Harrison Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Rockford acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to south Rockford and the main retail corridor.",
      icon: "ri-mail-line",
    },
    {
      id: "rock-2",
      name: "Loves Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1010 S Mulford Rd",
      city: "Loves Park",
      state: "IL",
      zip: "61111",
      phone: "(815) 633-3321",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Loves Park, approximately 5 miles north of downtown Rockford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Loves Park, Machesney Park, and northern Rockford residents.",
      icon: "ri-mail-line",
    },
    {
      id: "rock-3",
      name: "Belvidere Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 W Lincoln Ave",
      city: "Belvidere",
      state: "IL",
      zip: "61008",
      phone: "(815) 544-3731",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Belvidere, approximately 15 miles east of Rockford",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Belvidere, Cherry Valley, and eastern Boone County. Good alternative for east-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "rock-4",
      name: "Rockford Downtown Station",
      type: "USPS Passport Acceptance Facility",
      address: "100 N Main St",
      city: "Rockford",
      state: "IL",
      zip: "61101",
      phone: "(815) 963-3761",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Rockford, near the Rock River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for downtown Rockford, Swedish American Hospital area, and central city residents.",
      icon: "ri-mail-line",
    },
    {
      id: "rock-5",
      name: "Winnebago County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "404 Elm St",
      city: "Rockford",
      state: "IL",
      zip: "61101",
      phone: "(815) 319-4250",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Rockford, Winnebago County Building",
      website: "https://www.wincoil.us/",
      websiteLabel: "Winnebago County",
      notes: "Winnebago County Clerk passport acceptance. Extended hours compared to some post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 90-mile, 1.5-hour drive to Chicago via I-90", fpc: "No — ship from Rockford" },
    { feature: "Parking & Navigation", agency: "Downtown Chicago parking costs", fpc: "Ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Photo & Document Help", agency: "No guidance provided", fpc: "Yes — full document review included" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Rockford aerospace and healthcare professionals often discover passport issues just before departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near East State Street or Alpine Road sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Winnebago County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Rockford Post Office appointments fill during summer travel season and school break periods. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating the Trip to Chicago",
      description: "Many Rockford residents attempt to drive to the Chicago Passport Agency in an emergency. The 90-minute drive each way plus downtown parking and navigation means a full day lost — our courier service is faster and more reliable.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Spring break and summer travel from Rockford peaks March–August — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Rockford area or northern Illinois." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near State Street or East State Street in Rockford." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 90 minutes away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Rockford address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Rockford, IL?", a: "Fast Passport Center offers emergency passport processing in Rockford, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (90 minutes southeast via I-90) — without you making the trip." },
    { q: "Does Rockford have its own passport agency?", a: "No — Rockford does not have a regional passport agency. The nearest facility is the Chicago Passport Agency (approximately 90 minutes southeast via I-90). Fast Passport Center's courier service means Rockford residents never need to make the trip." },
    { q: "Can I get an expedited passport in Loves Park or Machesney Park?", a: "Absolutely. Fast Passport Center serves all of northern Illinois including Loves Park, Machesney Park, Belvidere, Rockton, Roscoe, South Beloit, and all of the Stateline area. Our service works the same way everywhere." },
    { q: "What airport do Rockford travelers use for international flights?", a: "Chicago O'Hare International Airport (ORD) is the primary airport for Rockford and northern Illinois travelers. O'Hare is approximately 90 minutes southeast via I-90 and offers direct international flights worldwide. Chicago Rockford International Airport (RFD) offers some domestic and seasonal international flights. Always verify passport validity for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Rockford, IL?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Rockford?", a: "Walgreens, CVS, and UPS Store locations throughout Rockford, Loves Park, and Machesney Park offer passport photos. FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Rockford aerospace workers?", a: "Yes. Fast Passport Center serves all of northern Illinois including Rockford aerospace professionals, Swedish American Hospital staff, and manufacturing workers. We understand corporate travel schedules and international business deadlines. Our courier service is especially valuable for workers who can't take a day off to drive to Chicago." },
    { q: "Can I get a passport for my child in Rockford?", a: "Yes. Fast Passport Center provides child passport services for minors under 16 throughout Rockford and northern Illinois. Both parents or legal guardians must typically be present at the acceptance facility, and we guide you through the entire process." },
  ],
  photoLocations: [
    { name: "Walgreens — Rockford State", address: "3342 E State St, Rockford, IL 61108", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Rockford", address: "308 N Alpine Rd, Rockford, IL 61107", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "CVS — Rockford Riverside", address: "2215 E Riverside Blvd, Loves Park, IL 61111", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Rockford", address: "5040 E State St, Rockford, IL 61108", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Rockford", address: "3720 E State St, Rockford, IL 61108", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Belvidere", address: "1200 N State St, Belvidere, IL 61008", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Belvidere, Cherry Valley, and eastern Boone County. Full REAL ID processing available.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Winnebago County birth and death certificates" },
    { label: "Marriage Licenses (Winnebago County Clerk)", url: "https://www.winnebagocountyil.gov/county-clerk", desc: "Winnebago County Clerk — marriage license applications and certified copies for Rockford and surrounding areas" },
    { label: "Divorce Decrees (Winnebago County Circuit Clerk)", url: "https://www.winnebagocountyil.gov/circuit-clerk", desc: "Winnebago County Circuit Clerk — divorce decree records for Rockford and Winnebago County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 90 minutes southeast via I-90",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Rockford and northern Illinois. One of the world's busiest airports with direct flights to Europe, Asia, and the Americas. United and American Airlines hub.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "RFD",
      name: "Chicago Rockford International Airport",
      distance: "Approximately 15 minutes south of Rockford via I-90",
      address: "60 Airport Dr, Rockford, IL 61109",
      note: "Growing regional airport with some domestic and seasonal international flights (Allegiant, Amazon Air cargo). Check for expanding international routes.",
      flightUrl: "https://www.flyrfd.com/",
      flightLabel: "RFD Flight Info",
      featured: false,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "Approximately 100 minutes southeast via I-90 and I-55",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Southwest Airlines hub with domestic connections. Good for travelers flying Southwest to connect to international destinations.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
};